/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.3",
    versionName: "0.2.0-nightly.2025.12.3",
    versionChannel: "nightly",
    buildDate: "2025-12-03T00:09:22.242Z",
    commitHash: "2a0761e2762b8c9427d7f685bdfcdb3bf3b7bd07",
};
